import moment from 'moment-timezone'
import { 
    homeIconPath2,
    solarIconPath,
    batteryIconPath,
    gridIconPath
  } from '../../../components/common/iconPaths'

import customColors from '../../../styles/mui/szPaletteOverrides.json'

const colors: any = {
    home: customColors?.palette?.home?.main, //'#006ff4',
    solar: customColors?.palette?.solar?.main, //'#E6D400',
    battery: customColors?.palette?.battery?.main, //'#00B04B',
    grid: customColors?.palette?.grid?.main, //'#C4C4CE',
    discharge: customColors?.palette?.battery?.main, //'#00B04B',
    import: customColors?.palette?.grid?.main, //'#C4C4CE',
    charge: customColors?.palette?.frombattery?.main, //'#008235',
    export: customColors?.palette?.fromgrid?.main, //'#8A8A8F',
    togrid: customColors?.palette?.grid?.main, //'#C4C4CE',
    fromgrid: customColors?.palette?.grid?.main, //'#8A8A8F',
    tobattery: customColors?.palette?.tobattery?.main,  //'#00B04B',
    frombattery: customColors?.palette?.frombattery?.main, //'#008235',
  }

const negativeColors = {
    home: customColors?.palette?.home?.main, //#006ff4',
    solar: customColors?.palette?.solar?.main, //'#E6D400',
    battery: customColors?.palette?.tobattery?.main, //'#008235',
    grid: customColors?.palette?.fromgrid?.main, //'#8A8A8F'
  }

const iconPaths: any = {
    home: homeIconPath2,
    solar: solarIconPath,
    battery: batteryIconPath,
    grid: gridIconPath
  }


function alwaysTwoDecimal(number: number) {
    if(!number) return '0.00'
    return Intl.NumberFormat('en-EN',{ 
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false,
    }).format(number);
}

const labels: any = {
    'home': 'home usage',
    'homebattery': 'from battery',
    'homegrid': 'from grid',
    'homesolar': 'from solar',
    'solar': 'solar production',
    'solarbattery': 'to battery',
    'solargrid': 'to grid',
    'solarhome': 'to home',
    'charge': 'battery charge',
    'discharge': 'battery discharge',
    'batteryhome': 'to home',
    'batterysolar': 'from solar',
    'batterytogrid': 'to grid',
    'batteryfromgrid': 'from grid',
    'import': 'grid import',
    'export': 'grid export',
    'gridhome': 'to home',
    'gridsolar': 'from solar',
    'gridtobattery': 'to battery',
    'gridfrombattery': 'from battery',
    'tobattery': 'to battery',
    'frombattery': 'from battery',
    'togrid': 'to grid',
    'fromgrid': 'from grid',
}
export default function getReportsData(data: any) {
    return {
        labels,
        colors,
        negativeColors,
        selectedData: {
            batteryStateOfCharge: data?.batteryStateOfCharge,
            tip: data?.tip,
            startDate: data?.startDate,
            timezone: data?.timezone,
            csvHeader: [
                { label: "Month Name", key: "month" },
                { label: "Day In Month", key: "day" },
                { label: "Accumulated Solar", key: "solar" },
                { label: "Accumulated Charge", key: "charge" },
                { label: "Accumulated Discharge", key: "discharge" },
                { label: "Accumulated Export", key: "export" },
                { label: "Accumulated Import", key: "import" },
                { label: "Accumulated Load", key: "load" },
                { label: "Accumulated EV Charge", key: "ev" },
              ],
            csvFileName: moment.tz(moment(data?.startDate),data?.timezone).format('MMMYYYY-')+'UsageReport.csv',
            referenceLine: data?.referenceLine,
            xAxesLabels: data?.xAxesLabels || [
                '12am','1','2','3','4','5','6','7','8','9','10','11','12',
                '1pm','2 ','3 ','4 ','5 ','6 ','7 ','8 ','9 ','10 ','11 ',
            ],
            home: {
                formatter: ((v: any)=>{
                    const h = [...data?.home?.series].sort((a:number,b:number)=>b-a)[0]
                    return v>=h?`${v} kWh`:v
                }),
                total: alwaysTwoDecimal(data?.home?.total),
                totalTitle: 'Total usage',
                average: data?.home?.average || 0,
                mondays: data?.home?.mondays,
                series: data?.home?.series || new Array(24).fill(0),
                stack:  (data?.home?.stack || []).map((s:any)=>({
                    values: s.series || new Array(24).fill(0),
                    id: s.id, color: colors[s.id]
                })),
                reportSubTitle: "Used from" ,
                reportDescription: `Your home has been powered ${data?.home?.summarySolar}% from solar, ${data?.home?.summaryBattery}% from battery and ${data?.home?.summaryGrid}% from the grid.`,
                summaryData: (data?.home?.summary || []).map((s:any)=>({
                    id: s.id, color: colors[s.id],
                    iconPath: iconPaths[s.id],
                    name: s.name,
                    kwh: alwaysTwoDecimal(s.kwh),
                    percent: Math.round(s.percent)
                }))
            },
            solar: {
                formatter: ((v: any)=>{
                    const h = [...data?.solar?.series].sort((a:number,b:number)=>b-a)[0]
                    return v>=h?`${v} kWh`:v
                }),
                total: alwaysTwoDecimal(data?.solar?.total),
                totalTitle: 'Total production',
                average: data?.solar?.average || 0,
                mondays: data?.solar?.mondays,
                series: data?.solar?.series || new Array(24).fill(0),
                stack:  (data?.solar?.stack || []).map((s:any)=>({
                    values: s.series || new Array(24).fill(0),
                    id: s.id, color: colors[s.id]
                })),
                reportSubTitle: "Used by" ,
                reportDescription: `From the solar energy your solar system has generated, ${data?.solar?.summaryHome}% was used by your home, ${data?.solar?.summaryBattery}% was stored in your battery and ${data?.solar?.summaryGrid}% exported to the grid. `,
                summaryData: (data?.solar?.summary || []).map((s:any)=>({
                    id: s.id, color: colors[s.id],
                    iconPath: iconPaths[s.id],
                    name: s.name,
                    kwh: alwaysTwoDecimal(s.kwh),
                    percent: Math.round(s.percent)
                }))
            },
            battery: {
                formatter: ((v: any)=>{
                    if(v>=data?.battery?.highestDischarge) return `${v} kWh\nDischarge`
                    if(v<0 && Math.abs(v)>=Math.abs(data?.battery?.lowestCharge)) 
                        return `${(v)} kWh\nCharge`
                    return `${(v)}`
                }),
                total: alwaysTwoDecimal(data?.battery?.total),
                total2: alwaysTwoDecimal(data?.battery?.total2),
                totalTitle: 'Total discharged',
                totalTitle2: 'Total charged',
                stackSeries: true,
                average: data?.battery?.average || 0,
                series: Object.keys(data?.battery?.series || []).map((k:any)=>({
                    id: k,
                    values: data?.battery?.series[k] || new Array(24).fill(0),
                    color: colors[k]
                })),
                stack:  (data?.battery?.stack || []).map((s:any)=>({
                    values: s.series || new Array(24).fill(0),
                    id: s.id, color: colors[s.id]
                })),
                reportSubTitle: "Discharged to" ,
                reportDescription: `${data?.battery?.summaryHome}% of the energy that was discharged out from the battery went to powering your home and ${data?.battery?.summaryToGrid}% went back into the grid. `,
                summaryData: (data?.battery?.summary || []).map((s:any)=>({
                    id: s.id, color: colors[s.id],
                    iconPath: iconPaths[s.id],
                    name: s.name,
                    kwh: alwaysTwoDecimal(s.kwh),
                    percent: Math.round(s.percent)
                })),
                reportSubTitle2: "Charged from" ,
                reportDescription2: `Your battery was charged ${data?.battery?.summarySolar}% from your solar panels and ${data?.battery?.summaryFromGrid}% from the grid.<br>The battery charges when it receives energy from solar panels or the grid, when energy prices are low, storing it for later use. It discharges when solar panels aren't generating enough power.`,
                summaryData2: (data?.battery?.summary2 || []).map((s:any)=>({
                    id: s.id==='grid'?'fromgrid':s.id, 
                    color: s.id==='grid'?colors.fromgrid:colors[s.id],
                    iconPath: iconPaths[s.id],
                    name: s.name,
                    kwh: alwaysTwoDecimal(s.kwh),
                    percent: Math.round(s.percent)
                }))
            },
            grid: {
                formatter: ((v: any)=>{
                    if(v>=data?.grid?.highestImport) return `${v} kWh\nImport`
                    if(v<0 && Math.abs(v)>=Math.abs(data?.grid?.lowestExport)) 
                        return `${(v)} kWh\nExport`
                    return `${(v)}`
                }),
                total: alwaysTwoDecimal(data?.grid?.total),
                total2: alwaysTwoDecimal(data?.grid?.total2),
                net: alwaysTwoDecimal(data?.grid?.total - data?.grid?.total2),
                netTitle: 'Net grid import',
                totalTitle: 'Total grid import',
                totalTitle2: 'Total grid export',
                stackSeries: true,
                average: data?.grid?.average || 0,
                series: Object.keys(data?.grid?.series || []).map((k:any)=>({
                    id: k,
                    values: data?.grid?.series[k] || new Array(24).fill(0),
                    color: colors[k]
                })),
                stack:  (data?.grid?.stack || []).map((s:any)=>({
                    values: s.series || new Array(24).fill(0),
                    id: s.id, color: colors[s.id]
                })),
                reportSubTitle: "Imported to" ,
                reportDescription: `${data?.grid?.summaryHome}% of the energy imported from the grid was used at home and ${data?.grid?.summaryToBattery}% was stored in your battery.`,
                summaryData: (data?.grid?.summary || []).map((s:any)=>({
                    id: s.id==='battery'?'tobattery':s.id, color: s.id==='battery'?colors.tobattery:colors[s.id],
                    iconPath: iconPaths[s.id],
                    name: s.name,
                    kwh: alwaysTwoDecimal(s.kwh),
                    percent: Math.round(s.percent)
                })),
                reportSubTitle2: "Exported from" ,
                reportDescription2: `${data?.grid?.summarySolar}% of the energy that your home exported to the grid came from solar, ${data?.grid?.summaryFromBattery}% from battery.<br>The battery charges when it receives energy from solar panels or the grid, storing it for later use. It discharges when this stored energy powers devices or feeds electricity to the grid when solar panels aren't generating enough power.`,
                summaryData2: (data?.grid?.summary2 || []).map((s:any)=>({
                    id: s.id==='battery'?'frombattery':s.id, color: s.id==='battery'?colors.frombattery:colors[s.id],
                    iconPath: iconPaths[s.id],
                    name: s.name,
                    kwh: alwaysTwoDecimal(s.kwh),
                    percent: Math.round(s.percent)
                }))
            },
            tou: data?.tou
        },
    }
}